import styles from "./ModalTitleContainer.module.scss";
import {CrossButtonBlack} from "../../../Buttons/CrossButton";
import clsx from "clsx";
import React, {FC} from "react";

interface ModalTitleContainerProps {
    title: string;
    onClose?: (e: any) => void;
    center?: boolean;
}

const ModalTitleContainer: FC<ModalTitleContainerProps> = ({title, onClose, center = true}) => {
    return <div className={clsx(styles.titleContainer, center ? styles.alignCenter : '')}>
        <div className={styles.popupTitle}>{title}</div>
        {onClose ? <CrossButtonBlack
            className={clsx("no-fastclick", styles.crossButtonDark)}
            onClick={onClose}
        /> : null}
    </div>
}

export default ModalTitleContainer;